/******/ (function() { // webpackBootstrap
var __webpack_exports__ = {};
class RuptureMerchHeightSync {
  constructor() {
    this.mobileMediaQuery = window.matchMedia('(max-width: 749px)');
    this.resizeObservers = new Map();
    this.animationFrame = null;
    this.scheduleRefresh = this.scheduleRefresh.bind(this);
    if (this.mobileMediaQuery.addEventListener) {
      this.mobileMediaQuery.addEventListener('change', this.scheduleRefresh);
    } else {
      this.mobileMediaQuery.addListener(this.scheduleRefresh);
    }
    document.addEventListener('collection:reloaded', this.scheduleRefresh);
    document.addEventListener('infinite-scroll:page-added', this.scheduleRefresh);
    document.addEventListener('shopify:section:load', this.scheduleRefresh);
    window.addEventListener('load', this.scheduleRefresh);
    this.scheduleRefresh();
  }
  scheduleRefresh() {
    window.cancelAnimationFrame(this.animationFrame);
    this.animationFrame = window.requestAnimationFrame(() => this.refresh());
  }
  refresh() {
    this.resizeObservers.forEach(observer => observer.disconnect());
    this.resizeObservers.clear();
    document.querySelectorAll('.rupture__merch-layout--1x2').forEach(merch => {
      merch.style.removeProperty('--rupture-merch-card-height');
      if (!this.mobileMediaQuery.matches) return;
      const productCard = this.findFollowingProductCard(merch);
      if (!productCard) return;
      const syncHeight = () => {
        const cardHeight = productCard.getBoundingClientRect().height;
        if (cardHeight > 0) {
          merch.style.setProperty('--rupture-merch-card-height', `${cardHeight}px`);
        }
      };
      syncHeight();
      const resizeObserver = new ResizeObserver(syncHeight);
      resizeObserver.observe(productCard);
      this.resizeObservers.set(merch, resizeObserver);
    });
  }
  findFollowingProductCard(merch) {
    let sibling = merch.nextElementSibling;
    while (sibling) {
      if (!sibling.classList.contains('rupture__merch-container') && sibling.querySelector('.card-wrapper')) {
        return sibling;
      }
      sibling = sibling.nextElementSibling;
    }
    return null;
  }
}
if (!window.ruptureMerchHeightSync) {
  window.ruptureMerchHeightSync = new RuptureMerchHeightSync();
} else {
  window.ruptureMerchHeightSync.scheduleRefresh();
}
/******/ })()
;